module.exports = __webpack_public_path__ + "static/media/close-camera.0ac5ccd5.svg";